import { render, staticRenderFns } from "./PhoneConfirmStatus.vue?vue&type=template&id=267a8179"
import script from "./PhoneConfirmStatus.vue?vue&type=script&lang=js"
export * from "./PhoneConfirmStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports